<template>
  <main-layout>
    
    <!-- Header -->
    <PageHeader
      icon="ri-lightbulb-line"
      title="Apoyo Estudiantil"
      subtitle="Recursos y enlaces de interés para tu desarrollo académico"
      :show-button="false" />

    <div class="content-container">
      
      <!-- Grid de recursos -->
      <div class="resources-grid">
        
        <!-- Recurso 1: My English Lab -->
        <a href="https://login.pearson.com/v1/piapi/iesui/signin?client_id=bWPoUiRnLpUhX2rhGeP4AaLCeyQYNYDA&redirect_uri=https%3A%2F%2Fenglish-dashboard.pearson.com%2Flogin&nonce=123454321&prompt=login&login_success_url=https%3A%2F%2Fenglish-dashboard.pearson.com%2Flogin%3FiesCode%3DDa8ieXtPEE" target="_blank" class="resource-card card-biblioteca">
          <div class="card-glow"></div>
          <div class="resource-content">
            <div class="resource-icon">
              <i class="ri-book-open-line"></i>
            </div>
            <h3 class="resource-title">My English Lab</h3>
            <p class="resource-description">Accede a libros, artículos y recursos educativos</p>
            <div class="resource-link">
              <span>Ir al recurso</span>
              <i class="ri-arrow-right-line"></i>
            </div>
          </div>
        </a>

        <!-- Recurso 2: Solicitudes Académicas -->
        <a href="https://americanschoolway.edu.co/solicitudes-academicas/" target="_blank" class="resource-card card-psicologia">
          <div class="card-glow"></div>
          <div class="resource-content">
            <div class="resource-icon">
              <i class="ri-file-list-3-line"></i>
            </div>
            <h3 class="resource-title">Solicitudes Académicas</h3>
            <p class="resource-description">Realiza solicitudes académicas y gestiona trámites relacionados</p>
            <div class="resource-link">
              <span>Ir al recurso</span>
              <i class="ri-arrow-right-line"></i>
            </div>
          </div>
        </a>

        <!-- Recurso 3: Modificaciones Académicas -->
        <a href="https://americanschoolway.edu.co/modificaciones/" target="_blank" class="resource-card card-becas">
          <div class="card-glow"></div>
          <div class="resource-content">
            <div class="resource-icon">
              <i class="ri-edit-2-line"></i>
            </div>
            <h3 class="resource-title">Modificaciones Académicas</h3>
            <p class="resource-description">Realiza modificaciones académicas y gestiona cambios en tu plan de estudios</p>
            <div class="resource-link">
              <span>Ir al recurso</span>
              <i class="ri-arrow-right-line"></i>
            </div>
          </div>
        </a>

        <!-- Recurso 4: Clubes y eventos -->
        <a href="https://americanschoolway.edu.co/nuevos-estudiantes/#eventos" target="_blank" class="resource-card card-tutorias-acad">
          <div class="card-glow"></div>
          <div class="resource-content">
            <div class="resource-icon">
              <i class="ri-calendar-event-line"></i>
            </div>
            <h3 class="resource-title">Clubes y eventos</h3>
            <p class="resource-description">Participa en clubes y eventos organizados por ASW</p>
            <div class="resource-link">
              <span>Ir al recurso</span>
              <i class="ri-arrow-right-line"></i>
            </div>
          </div>
        </a>

        <!-- Recurso 5: Activación de Tutorías -->
        <a href="https://wa.link/iak2wt" target="_blank" class="resource-card card-escritura">
          <div class="card-glow"></div>
          <div class="resource-content">
            <div class="resource-icon">
              <i class="ri-user-voice-line"></i>
            </div>
            <h3 class="resource-title">Activación de Tutorías</h3>
            <p class="resource-description">Activa tus tutorías y gestiona tus sesiones académicas</p>
            <div class="resource-link">
              <span>Ir al recurso</span>
              <i class="ri-arrow-right-line"></i>
            </div>
          </div>
        </a>
      </div>

    </div>

  </main-layout>
</template>

<script>
import MainLayout from './Layout/MainLayout.vue';
import PageHeader from './Layout/PageHeader.vue';

export default {
  name: 'ApoyoEstudiantil',
  components: {
    MainLayout,
    PageHeader
  }
}
</script>

<style scoped>
/* ============================================================================
   GRID DE RECURSOS
   ============================================================================ */
.resources-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  animation: fadeInUp 0.6s ease-out;
}

@media (min-width: 768px) {
  .resources-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .resources-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============================================================================
   TARJETAS DE RECURSOS
   ============================================================================ */
.resource-card {
  position: relative;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 16px;
  padding: 1.75rem;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  display: block;
  min-height: 200px;
}

.resource-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--theme-shadow-lg);
  border-color: var(--theme-border-color-strong);
  text-decoration: none;
}

/* Efecto de brillo al hover */
.card-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: var(--theme-radial-primary);
  opacity: 0;
  transition: opacity 0.5s ease;
  pointer-events: none;
}

.resource-card:hover .card-glow {
  opacity: 0.6;
}

/* ============================================================================
   CONTENIDO DE TARJETAS
   ============================================================================ */
.resource-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
}

.resource-icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.75rem;
  transition: all 0.3s ease;
}

.resource-card:hover .resource-icon {
  transform: scale(1.1);
}

.resource-title {
  font-family: var(--app-font-family);
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
  line-height: 1.3;
}

.resource-description {
  font-family: var(--app-font-family);
  font-size: 0.9rem;
  color: var(--theme-text-secondary);
  margin: 0;
  flex: 1;
  line-height: 1.5;
}

.resource-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--app-font-family);
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--app-primary-blue);
  transition: all 0.3s ease;
}

.resource-card:hover .resource-link {
  gap: 0.75rem;
}

.resource-link i {
  transition: transform 0.3s ease;
}

.resource-card:hover .resource-link i {
  transform: translateX(4px);
}

/* ============================================================================
   ESTILOS ESPECÍFICOS POR TIPO DE RECURSO (COMENTADOS - USO FUTURO)
   ============================================================================ */

/* Biblioteca Virtual - Azul */
/* .card-biblioteca {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.1) 0%, rgba(79, 172, 254, 0.08) 100%);
}

.card-biblioteca .resource-icon {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.3) 0%, rgba(79, 172, 254, 0.3) 100%);
  color: var(--app-primary-blue);
}

.card-biblioteca:hover {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.15) 0%, rgba(79, 172, 254, 0.12) 100%);
  border-color: rgba(13, 78, 140, 0.4);
  box-shadow: 0 8px 24px rgba(13, 78, 140, 0.2);
} */

/* Apoyo Psicológico - Verde */
/* .card-psicologia {
  background: linear-gradient(135deg, rgba(52, 199, 89, 0.1) 0%, rgba(48, 209, 88, 0.08) 100%);
}

.card-psicologia .resource-icon {
  background: linear-gradient(135deg, rgba(52, 199, 89, 0.3) 0%, rgba(48, 209, 88, 0.3) 100%);
  color: #34c759;
}

.card-psicologia:hover {
  background: linear-gradient(135deg, rgba(52, 199, 89, 0.15) 0%, rgba(48, 209, 88, 0.12) 100%);
  border-color: rgba(52, 199, 89, 0.4);
  box-shadow: 0 8px 24px rgba(52, 199, 89, 0.2);
} */

/* Becas - Amarillo */
/* .card-becas {
  background: linear-gradient(135deg, rgba(241, 196, 0, 0.1) 0%, rgba(255, 215, 0, 0.08) 100%);
}

.card-becas .resource-icon {
  background: linear-gradient(135deg, rgba(241, 196, 0, 0.3) 0%, rgba(255, 215, 0, 0.3) 100%);
  color: var(--app-primary-yellow);
}

.card-becas:hover {
  background: linear-gradient(135deg, rgba(241, 196, 0, 0.15) 0%, rgba(255, 215, 0, 0.12) 100%);
  border-color: rgba(241, 196, 0, 0.4);
  box-shadow: 0 8px 24px rgba(241, 196, 0, 0.25);
} */

/* Tutorías Académicas - Cyan */
/* .card-tutorias-acad {
  background: linear-gradient(135deg, rgba(79, 172, 254, 0.1) 0%, rgba(0, 242, 254, 0.08) 100%);
}

.card-tutorias-acad .resource-icon {
  background: linear-gradient(135deg, rgba(79, 172, 254, 0.3) 0%, rgba(0, 242, 254, 0.3) 100%);
  color: #4FACFE;
}

.card-tutorias-acad:hover {
  background: linear-gradient(135deg, rgba(79, 172, 254, 0.15) 0%, rgba(0, 242, 254, 0.12) 100%);
  border-color: rgba(79, 172, 254, 0.4);
  box-shadow: 0 8px 24px rgba(79, 172, 254, 0.2);
} */

/* Centro de Escritura - Púrpura */
/* .card-escritura {
  background: linear-gradient(135deg, rgba(175, 82, 222, 0.1) 0%, rgba(191, 90, 242, 0.08) 100%);
}

.card-escritura .resource-icon {
  background: linear-gradient(135deg, rgba(175, 82, 222, 0.3) 0%, rgba(191, 90, 242, 0.3) 100%);
  color: #AF52DE;
}

.card-escritura:hover {
  background: linear-gradient(135deg, rgba(175, 82, 222, 0.15) 0%, rgba(191, 90, 242, 0.12) 100%);
  border-color: rgba(175, 82, 222, 0.4);
  box-shadow: 0 8px 24px rgba(175, 82, 222, 0.2);
} */

/* Tecnología - Rojo */
/* .card-tecnologia {
  background: linear-gradient(135deg, rgba(188, 35, 54, 0.1) 0%, rgba(220, 60, 80, 0.08) 100%);
}

.card-tecnologia .resource-icon {
  background: linear-gradient(135deg, rgba(188, 35, 54, 0.3) 0%, rgba(220, 60, 80, 0.3) 100%);
  color: var(--app-primary-red);
}

.card-tecnologia:hover {
  background: linear-gradient(135deg, rgba(188, 35, 54, 0.15) 0%, rgba(220, 60, 80, 0.12) 100%);
  border-color: rgba(188, 35, 54, 0.4);
  box-shadow: 0 8px 24px rgba(188, 35, 54, 0.2);
} */

/* Orientación Vocacional - Naranja */
/* .card-vocacional {
  background: linear-gradient(135deg, rgba(255, 149, 0, 0.1) 0%, rgba(255, 179, 64, 0.08) 100%);
}

.card-vocacional .resource-icon {
  background: linear-gradient(135deg, rgba(255, 149, 0, 0.3) 0%, rgba(255, 179, 64, 0.3) 100%);
  color: #ff9500;
}

.card-vocacional:hover {
  background: linear-gradient(135deg, rgba(255, 149, 0, 0.15) 0%, rgba(255, 179, 64, 0.12) 100%);
  border-color: rgba(255, 149, 0, 0.4);
  box-shadow: 0 8px 24px rgba(255, 149, 0, 0.25);
} */

/* Actividades Extracurriculares - Teal */
/* .card-actividades {
  background: linear-gradient(135deg, rgba(90, 200, 250, 0.1) 0%, rgba(100, 210, 255, 0.08) 100%);
}

.card-actividades .resource-icon {
  background: linear-gradient(135deg, rgba(90, 200, 250, 0.3) 0%, rgba(100, 210, 255, 0.3) 100%);
  color: #5AC8FA;
}

.card-actividades:hover {
  background: linear-gradient(135deg, rgba(90, 200, 250, 0.15) 0%, rgba(100, 210, 255, 0.12) 100%);
  border-color: rgba(90, 200, 250, 0.4);
  box-shadow: 0 8px 24px rgba(90, 200, 250, 0.2);
} */

/* FAQ - Verde Menta */
/* .card-faq {
  background: linear-gradient(135deg, rgba(52, 199, 89, 0.1) 0%, rgba(93, 226, 120, 0.08) 100%);
}

.card-faq .resource-icon {
  background: linear-gradient(135deg, rgba(52, 199, 89, 0.3) 0%, rgba(93, 226, 120, 0.3) 100%);
  color: #34c759;
}

.card-faq:hover {
  background: linear-gradient(135deg, rgba(52, 199, 89, 0.15) 0%, rgba(93, 226, 120, 0.12) 100%);
  border-color: rgba(52, 199, 89, 0.4);
  box-shadow: 0 8px 24px rgba(52, 199, 89, 0.2);
} */

/* ============================================================================
   COLOR UNIVERSAL AZUL CORPORATIVO (ACTIVO)
   ============================================================================ */
.card-biblioteca,
.card-psicologia,
.card-becas,
.card-tutorias-acad,
.card-escritura,
.card-tecnologia,
.card-vocacional,
.card-actividades,
.card-faq {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.1) 0%, rgba(79, 172, 254, 0.08) 100%);
}

.card-biblioteca .resource-icon,
.card-psicologia .resource-icon,
.card-becas .resource-icon,
.card-tutorias-acad .resource-icon,
.card-escritura .resource-icon,
.card-tecnologia .resource-icon,
.card-vocacional .resource-icon,
.card-actividades .resource-icon,
.card-faq .resource-icon {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.3) 0%, rgba(79, 172, 254, 0.3) 100%);
  color: var(--app-primary-blue);
}

.card-biblioteca:hover,
.card-psicologia:hover,
.card-becas:hover,
.card-tutorias-acad:hover,
.card-escritura:hover,
.card-tecnologia:hover,
.card-vocacional:hover,
.card-actividades:hover,
.card-faq:hover {
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.15) 0%, rgba(79, 172, 254, 0.12) 100%);
  border-color: rgba(13, 78, 140, 0.4);
  box-shadow: 0 8px 24px rgba(13, 78, 140, 0.2);
}

/* ============================================================================
   RESPONSIVE - OPTIMIZADO PARA MÓVIL
   ============================================================================ */
@media (max-width: 768px) {
  .resource-card {
    padding: 1.25rem;
    min-height: 150px;
  }

  .resource-content {
    gap: 0.75rem;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas:
      "icon title"
      "desc desc"
      "link link";
    column-gap: 0.875rem;
    row-gap: 0.75rem;
  }

  .resource-icon {
    grid-area: icon;
    width: 44px;
    height: 44px;
    font-size: 1.4rem;
    margin: 0;
  }

  .resource-title {
    grid-area: title;
    font-size: 1.1rem;
    align-self: center;
  }

  .resource-description {
    grid-area: desc;
    font-size: 0.85rem;
    line-height: 1.4;
  }

  .resource-link {
    grid-area: link;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .resources-grid {
    gap: 0.75rem;
  }

  .resource-card {
    padding: 1rem;
    min-height: 120px;
    border-radius: 12px;
  }

  .resource-content {
    grid-template-columns: auto 1fr;
    grid-template-areas:
      "icon title"
      "desc desc"
      "link link";
    column-gap: 0.75rem;
    row-gap: 0.625rem;
  }

  .resource-icon {
    width: 40px;
    height: 40px;
    font-size: 1.25rem;
    border-radius: 10px;
  }

  .resource-title {
    font-size: 0.95rem;
    line-height: 1.2;
  }

  .resource-description {
    font-size: 0.8rem;
    line-height: 1.35;
  }

  .resource-link {
    font-size: 0.8rem;
  }
}
</style>
